import { useCallback } from "react";
import {
	Resources,
	useResource,
} from "web_myplann/Infrastructure/Translations/Resources";

export const useFormatGoalAmount = () => {
	const { t } = useResource();

	return useCallback(
		(amount: number): string => {
			if (amount >= 1000000) {
				const mil = amount / 1000000;
				const formatted =
					mil % 1 === 0 ? mil.toFixed(0) : mil.toFixed(1).replace(".", ",");
				return `${formatted} ${t(Resources.Goals.Amount.millions)}`;
			}
			if (amount >= 100000) {
				const tis = Math.round(amount / 1000);
				return `${tis} ${t(Resources.Goals.Amount.thousands)}`;
			}
			return amount.toLocaleString("cs-CZ");
		},
		[t],
	);
};
